import { state } from '@/shared/components/player/store';

export default {
  computed: {
    nextElement() {
      const nextElement = state.nextEpisode.id
        ? state.nextEpisode
        : state.nextRelatedProduct;

      return state.isEmbedded
        ? nextElement
        : {};
    },
  },
  methods: {
    playNextElement() {
      if (!state.isEmbedded) {
        return;
      }

      if (state.nextEpisode.id) {
        return this.playNextEpisode();
      }

      if (state.nextRelatedProduct.id) {
        return this.playNextRelatedProduct();
      }
    },
  },
};
